<div class="component-viewer">
    <h2>Iteration</h2>
    <mat-card class="mb-3">
        <mat-card-content>
            <div class="container-fluid">
                <div class="row">
                    <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
                </div>
                <div class="row">
                    <div class="col-3">
                        <div>Course Name</div>
                    </div>
                    <div class="col">
                        <div>Cost</div>
                    </div>
                    <div class="col">
                        <div>Credit Card Fee</div>
                    </div>
                    <div class="col">
                        <div>Start Date</div>
                    </div>
                    <div class="col" *ngIf="iteration.registrationCode">
                        <div>Registration Code</div>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-3">
                        <div>{{iteration.courseName}}</div>
                    </div>
                    <div class="col">
                        <div>${{iteration.cost}}</div>
                    </div>
                    <div class="col">
                        <div>${{iteration.creditCardFee}}</div>
                    </div>
                    <div class="col">
                        <div>{{iteration.startDate | date: 'mediumDate'}}</div>
                    </div>
                    <div class="col" *ngIf="iteration.registrationCode">
                        <div>{{iteration.registrationCode }}</div>
                    </div>
                </div>
            </div>
        </mat-card-content>
        <mat-card-actions>
            <div class="container-fluid">
                <div class="row">
                    <div class="col">
                        <button mat-raised-button [routerLink]="['../../../iteration/edit/', id]">Edit
                            <mat-icon>edit</mat-icon></button>
                    </div>
                </div>
            </div>
        </mat-card-actions>
    </mat-card>
    <hr />
    <h2>Details</h2>
    <mat-card>
        <mat-card-header>
            <div class="container-fluid">
                <div class="row" *ngIf="canEditOrDelete()">
                    <form [formGroup]="form" (ngSubmit)="onSubmit(form)">
                        <div class="row align-items-center">
                            <div class="col">
                                <mat-form-field class="margin-right">
                                    <input matInput required name="name" id="name" placeholder="Name" type="text"
                                        formControlName="name" />
                                    <mat-error *ngIf="form.get('name').errors?.required">Name is required
                                    </mat-error>
                                    <mat-error *ngIf="form.get('name').errors?.validationErrors">
                                        {{ form.get("name").errors?.validationErrors}}
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="col">
                                <mat-form-field>
                                    <input matInput name="description" id="description" placeholder="Description"
                                        type="text" formControlName="description" />
                                </mat-form-field>
                            </div>
                            <div class="col">
                                <mat-form-field>
                                    <input matInput name="cost" id="cost" type="text" formControlName="cost"
                                        placeholder="Cost" />
                                </mat-form-field>
                            </div>
                            <div class="col">
                                <mat-form-field>
                                    <input matInput name="notes" id="notes" type="text" formControlName="notes"
                                        placeholder="Notes" />
                                </mat-form-field>
                            </div>
                            <div class="col">
                                <button mat-raised-button>Add <mat-icon>add</mat-icon></button>
                            </div>
                        </div>
                    </form>
                    <hr />
                </div>
            </div>
        </mat-card-header>
        <mat-card-content>
            <div class="row">
                <mat-progress-bar mode="indeterminate" *ngIf="isDetailsLoading"></mat-progress-bar>
            </div>
            <div class="row">
                <gt-table *ngIf="iterationDetails" [loading]="isLoading" [defaultPageSize]="10"
                [updateFilterEvent]="updateFilterEvent" [filter]="filter" [data]="iterationDetails"
                (filterChanged)="getIterationDetails()" (filterReset)="resetFilter()">
            </gt-table>
            <table mat-table [dataSource]="iterationDetails">
                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef>Name </th>
                    <td mat-cell *matCellDef="let detail"> {{detail.name}} </td>
                </ng-container>
                <ng-container matColumnDef="description">
                    <th mat-header-cell *matHeaderCellDef>Description </th>
                    <td mat-cell *matCellDef="let detail"> {{detail.description}} </td>
                </ng-container>
                <ng-container matColumnDef="cost">
                    <th mat-header-cell *matHeaderCellDef>Cost </th>
                    <td mat-cell *matCellDef="let detail"> ${{detail.cost}} </td>
                </ng-container>
                <ng-container matColumnDef="notes">
                    <th mat-header-cell *matHeaderCellDef>Notes </th>
                    <td mat-cell *matCellDef="let detail"> {{detail.notes}} </td>
                </ng-container>
                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let detail">
                        <button mat-stroked-button *ngIf="canEditOrDelete()" (click)="edit(detail)">Edit
                            <mat-icon>edit</mat-icon></button>&nbsp;
                        <button mat-stroked-button color="warn" *ngIf="canEditOrDelete()"
                            (click)="delete(detail)">Delete <mat-icon>edit</mat-icon></button>&nbsp;
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
            </div>
        </mat-card-content>
    </mat-card>
</div>